import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Card } from '../ui/Card';
import { AlertTriangleIcon, FlagIcon } from 'lucide-react';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
export function Problem() {
  const {
    lang
  } = useLang();
  const t = dictionary.problem;
  return <section id="problem" className="relative py-24 md:py-32 bg-white tech-grid-light" data-id="element-446">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-447">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-448" />

        <div className="mt-14 grid md:grid-cols-2 gap-5" data-id="element-449">
          <Card className="p-7 md:p-9" delay={0.05} data-id="element-450">
            <div className="flex items-center gap-3 mb-5" data-id="element-451">
              <div className="w-9 h-9 flex items-center justify-center bg-petroleum/10 border border-petroleum/20 rounded-sm" data-id="element-452">
                <FlagIcon className="w-4 h-4 text-petroleum" data-id="element-453" />
              </div>
              <h3 className="font-serif text-xl text-navy-deep" data-id="element-454">
                {t.suppliersTitle[lang]}
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-455">
              {t.suppliers[lang].map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-slate-700" data-id="element-456">
                  <AlertTriangleIcon className="w-4 h-4 text-gold-deep mt-0.5 shrink-0" data-id="element-457" />
                  <span data-id="element-458">{item}</span>
                </li>)}
            </ul>
          </Card>

          <Card className="p-7 md:p-9" delay={0.15} data-id="element-459">
            <div className="flex items-center gap-3 mb-5" data-id="element-460">
              <div className="w-9 h-9 flex items-center justify-center bg-gold/10 border border-gold/30 rounded-sm" data-id="element-461">
                <FlagIcon className="w-4 h-4 text-gold-deep" data-id="element-462" />
              </div>
              <h3 className="font-serif text-xl text-navy-deep" data-id="element-463">
                {t.buyersTitle[lang]}
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-464">
              {t.buyers[lang].map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-slate-700" data-id="element-465">
                  <AlertTriangleIcon className="w-4 h-4 text-gold-deep mt-0.5 shrink-0" data-id="element-466" />
                  <span data-id="element-467">{item}</span>
                </li>)}
            </ul>
          </Card>
        </div>
      </div>
    </section>;
}